import { Button, Stack } from "@mui/material";
import { Kind, ResourceConfiguration, Role } from "../../graphql/generated";
import { ActionsSection } from "../DialogComponents";
import { ViewHeading } from "./ViewHeading";
import { RBACWrapper } from "../RBACWrapper/RBACWrapper";
import { ResourceConfigurationsContainer } from "../ResourceConfigurationsContainer";

import mixins from "../../styles/mixins.module.scss";

interface AllItemsProps {
  items: ResourceConfiguration[];
  readOnly: boolean;
  resourceKind: Kind.Processor | Kind.Extension;
  onAddItem: () => void;
  onEditItem: (index: number) => void;
  onSave: () => void;
  onItemsChange: (items: ResourceConfiguration[]) => void;
}

/**
 * AllItems view shows the initial view of the resource configuration editing dialog, which is a list of all items,
 * with the ability to add a new item, reorder items, and select an item to edit or delete.
 */
export const AllItemsView: React.FC<AllItemsProps> = ({
  onSave,
  readOnly,
  resourceKind,
  ...resourceContainerProps
}) => {
  return (
    <Stack className={mixins["flex-grow"]}>
      <ViewHeading heading={`${resourceKind}s`} />
      <ResourceConfigurationsContainer
        resourceKind={resourceKind}
        readOnly={readOnly}
        {...resourceContainerProps}
      />
      {!readOnly && (
        <ActionsSection>
          <RBACWrapper requiredRole={Role.User}>
            <Button variant="contained" onClick={onSave}>
              Save
            </Button>
          </RBACWrapper>
        </ActionsSection>
      )}
    </Stack>
  );
};
